import { AxiosResponse } from "axios";
import * as React from "react";
import styled from "styled-components";

import { GetLocalizedMessage } from "../../../../reducers/course-author/types";
import colors from "../../../../styles/colors";
import { PreferredLocale } from "../../../../utils/locales";
import { HTMLRenderer } from "../../../course-author/html-editor/Renderer";
import Spinner from "../../../utils/Spinner";

interface ILocalizedMessageProps {
  getMessage: GetLocalizedMessage;
  locale: PreferredLocale;
  title: string;
}

interface ILocalizedMessageState {
  loading: boolean;
  message: string;
}

const CustomMessagePreview = styled.div`
  margin-bottom: 1rem;
`;

const IndentedMessage = styled.div`
  margin: 0.5rem 2rem;
  background-color: ${colors.lightgrey2};
`;

const Title = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.smallText};
`;

export default class LocalizedMessage extends React.PureComponent<ILocalizedMessageProps, ILocalizedMessageState> {
  constructor(props: ILocalizedMessageProps) {
    super(props);
    this.state = {
      loading: true,
      message: "",
    };
  }

  public componentDidMount() {
    const { locale } = this.props;
    this.solvePromiseForLocale(locale);
  }

  public componentDidUpdate(oldProps: ILocalizedMessageProps) {
    const { locale } = this.props;
    if (oldProps.locale !== locale) {
      this.setState({ loading: true }, () => {
        this.solvePromiseForLocale(locale);
      });
    }
  }

  public render() {
    const { loading, message } = this.state;
    if (loading) {
      return <Spinner />;
    }
    return (
      <CustomMessagePreview>
        <Title>{this.props.title}</Title>
        <IndentedMessage>
          <HTMLRenderer source={message} />
        </IndentedMessage>
      </CustomMessagePreview>
    );
  }

  private solvePromiseForLocale = (locale: PreferredLocale): void => {
    this.props.getMessage(locale).then(([err, resp]) => {
      if (err) {
        this.setState({ loading: false, message: err });
      } else {
        this.setState({
          loading: false,
          message: (resp as AxiosResponse<string>).data,
        });
      }
    });
  };
}
